import React from 'react';
import InputField from '../../../../common/InputField';
import SelectOption from './../../../../common/SelectOption';
import {additionalEmailValidation, emailValidation, nameValidation, numberRegexValidation} from "../../../../../helper/FeildValidations";
import {COUNTRY_CODES} from '../../../../common/constants'

const Host = () => {
  const rules = [
    {
      required: true,
      message: 'Please Fill Input Field!',
    },
  ];

  return (
    <div className="basic-details-wrapper">
      <InputField name={['spaceOwner', 'firstName']} label={'First Name'} rules={nameValidation} />
      <InputField name={['spaceOwner', 'lastName']} label={'Last Name'} rules={nameValidation} />
      <SelectOption
        isMultiple={false}
        name={['spaceOwner', 'country']}
        placeholder={'Country Code'}
        rules={rules}
        label={'Country Code'}
        values={COUNTRY_CODES}
        handleOnSelect={null}
        labelName={'label'}
        valueName={'code'}
      />
      <InputField name={['spaceOwner', 'phoneNumbers', 0]} label={'Number'} rules={numberRegexValidation} />
      <InputField name={['spaceOwner', 'email']} label={'Email Address'} rules={emailValidation} />
      <InputField name={['spaceOwner', 'additionalEmail']} label={'Additional Email Address'} rules={additionalEmailValidation} />
    </div>
  );
};

export default Host;
